const base = "http://donate.n3rds.care/api/v1/events/mindcrack-marathon-2017/";
const biddings = base + "incentives/biddings/";
const tresh = base + "incentives/thresholds/";
const dons = base + "donations/?limit=5";
const eventDetails = () => fetch(base).then(r => r.json());
const bidwars = () => fetch(biddings).then(r => r.json());
const tresholds = () => fetch(tresh).then(r => r.json());

const donations = () => fetch(dons).then(r => r.json());

const formatBids = bids => {
  return bids.reduce((acc, c, i) => {
    return {
      ...acc,
      [c.title]: {
        hidden: true,
        props: {
          title: { type: "text", value: c.title, readOnly: true },
          size: { type: "number", value: c.items.length, readOnly: true },
          vsProgress: {
            type: "number",
            readOnly: true,
            value:
              c.items[0] && c.items[1]
                ? Math.floor(c.items[0].amount * 100 / (c.items[0].amount + c.items[1].amount))
                : 0
          },
          items: {
            type: "list",
            readOnly: true,
            value: c.items.reduce((acc, c, bi) => {
              return { ...acc, ["_bidItem" + i + bi]: 1 };
            }, {})
          }
        }
      },
      ...c.items.reduce((acc, c, bi) => {
        return {
          ...acc,
          ["_bidItem" + i + bi]: {
            hidden: true,
            props: {
              name: { type: "text", value: c.name, readOnly: true },
              amount: { type: "number", value: c.amount, readOnly: true }
            }
          }
        };
      }, {})
    };
  }, {});
};

var queue = [];
var previous = [];

const donId = d => "" + d.name_display + d.amount + d.date_created;

const newDons = (prevs, currents) => {
  return currents.filter(c => !prevs.includes(donId(c)));
};

const getLastDonation = donations => {
  const news = newDons(previous, donations).reverse();
  previous = donations.map(d => donId(d));
  queue = queue.concat(news);
  return queue.length > 1 ? queue.shift() : queue[0];
};

const getMindDatas = cb => {
  Promise.all([
    eventDetails(),
    bidwars(),
    tresholds(),
    donations()
  ]).then(([eventd, bids, tre, dona]) => {
    const nextTresh = tre
      .map(t => t.amount)
      .filter(t => t > eventd.amount)
      .sort()[0];
    const lastDona = getLastDonation(dona);
    cb(
      {
        totalRaised: { type: "number", value: eventd.amount },
        totalRaisedFormat: { type: "text", value: eventd.amount.toLocaleString() },
        bidwars: {
          type: "list",
          value: bids.reduce((acc, c, i) => {
            return { ...acc, [c.title]: 1 };
          }, {})
        },
        nextTreshold: {
          type: "number",
          value: nextTresh
        },
        nextTresholdFormat: {
          type: "text",
          value: nextTresh.toLocaleString()
        },
        currentProgress: {
          type: "number",
          value: Math.floor(eventd.amount * 100 / nextTresh)
        },
        lastDonation: {
          type: "number",
          value: lastDona.amount
        },
        lastDonationUser: {
          type: "text",
          value: lastDona.name_display
        }
      },
      formatBids(bids)
    );
  });
};

var refresher = undefined;

export default (params, id, cb) => {
  if (!refresher) {
    getMindDatas(cb);
    refresher = setInterval(() => {
      getMindDatas(cb);
    }, 5000);
  }
};



// WEBPACK FOOTER //
// ./src/spreadsheet/providers/mindcrack.js